import axiosInstance from "../utils/axios"

export const userService = {
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get('/user', {
      params,
    })
    return response.data
  },
  findById: async (id) => {
    const response = await axiosInstance.get('/user/'+id)
    return response.data
  },
  store: async (data) => {
    const response = await axiosInstance.post('/user', data)
    return response.data
  },
  update: async (id, data) => {
    const response = await axiosInstance.put(`/user/${id}`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await axiosInstance.delete(`/user/${id}`)
    return response.data
  },
}
